export default __webpack_public_path__ + "static/media/4.f6ef9c31.jpg";